<template>
  <div class="admin-home">
    <h2 class="page-title">Welcome to Axion Academy Admin Panel</h2>

    <!-- Dashboard Stats -->
    <div class="stats-container">
      <div class="stat-card">
        <div class="stat-top">
          <i class="bi bi-people-fill stat-icon"></i>
          <span class="stat-count">{{ totalStudents }}</span>
        </div>
        <p class="stat-label">Students</p>
      </div>
      <div class="stat-card">
        <div class="stat-top">
          <i class="bi bi-book-fill stat-icon"></i>
          <span class="stat-count">{{ totalSubjects }}</span>
        </div>
        <p class="stat-label">Subjects</p>
      </div>
      <div class="stat-card">
        <div class="stat-top">
          <i class="bi bi-play-btn-fill stat-icon"></i>
          <span class="stat-count">{{ totalVideos }}</span>
        </div>
        <p class="stat-label">Video Lessons</p>
      </div>

      <div class="stat-card">
        <div class="stat-top">
          <i class="bi bi-cash-coin stat-icon"></i>
          <span class="stat-count">{{ totalPayments }}</span>
        </div>
        <p class="stat-label">Payments</p>
      </div>
    </div>

    <!-- Recent Activity / Notes -->
    <div class="recent-activity">
      <h4>Recent Activity</h4>
      <ul>
        <li v-for="(activity, index) in recentActivity" :key="index">
          {{ activity }}
        </li>
      </ul>
    </div>

    <div>
      <SubjectPage />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SubjectPage from "@/components/MySubjects/SubjectPage.vue";

export default {
  name: "AdminHome",
  data() {
    return {
      totalStudents: 0,
      totalSubjects: 0,
      totalVideos: 0,
      totalPayments: 0,
      recentActivity: [],
    };
  },

  components: {
    SubjectPage,
  },

  mounted() {
    this.getDashboardStats();
    this.getRecentActivity();
  },

  methods: {
    async getDashboardStats() {
      try {
        const response = await axios.get("/ad-dashboard-stats", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        this.animateCount("totalStudents", response.data.totalStudents);
        this.animateCount("totalSubjects", response.data.totalSubjects);
        this.animateCount("totalVideos", response.data.totalVideos);
        this.animateCount("totalPayments", response.data.totalPayments);

        this.recentActivity = response.data.recentActivity;
      } catch (error) {
        console.error("Error fetching stats:", error);

        if (error.response && error.response.status === 401) {
          localStorage.clear();
          this.$router.push("/admin-login");
        }
      }
    },

    animateCount(field, target) {
      let start = 0;
      const duration = 1500; // total animation time (ms)
      const increment = target / (duration / 20); // speed control

      const counter = setInterval(() => {
        start += increment;

        if (start >= target) {
          this[field] = target;
          clearInterval(counter);
        } else {
          this[field] = Math.floor(start);
        }
      }, 20);
    },

    async getRecentActivity() {
      try {
        const response = await axios.get("/ad-dashboard-re-activity", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        this.animateCount("totalStudents", response.data.totalStudents);
        this.animateCount("totalSubjects", response.data.totalSubjects);
        this.animateCount("totalVideos", response.data.totalVideos);
        this.animateCount("totalPayments", response.data.totalPayments);

        this.recentActivity = response.data.recentActivity;
      } catch (error) {
        console.error("Error fetching recent activity:", error);

        if (error.response && error.response.status === 401) {
          localStorage.clear();
          this.$router.push("/admin-login");
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.admin-home {
  color: white;

  .page-title {
    text-align: center;
    margin-bottom: 30px;
    color: #ff00cc;
    text-shadow: 0 0 10px #ff00cc, 0 0 20px #ff00cc;
  }

  .stats-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 20px;
    margin-bottom: 40px;

    .stat-card {
      background: #1a001f;
      border-radius: 15px;
      padding: 20px;
      text-align: center;
      box-shadow: 0 0 20px rgba(255, 0, 204, 0.5);
      transition: transform 0.3s;

      &:hover {
        transform: translateY(-5px);
      }

      .stat-top {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin-bottom: 10px;
      }

      .stat-icon {
        font-size: 2rem;
        color: #ff00cc;
      }

      .stat-count {
        font-size: 2rem;
        font-weight: bold;
        color: #ff00cc;
      }

      .stat-label {
        color: #ccc;
        font-weight: bold;
        font-size: 1rem;
      }
    }
  }

  .recent-activity {
    background: #1a001f;
    border-radius: 15px;
    padding: 20px;
    box-shadow: 0 0 20px rgba(255, 0, 204, 0.5);

    h4 {
      margin-bottom: 15px;
      color: #ff00cc;
    }

    ul {
      list-style: disc inside;
      li {
        margin-bottom: 8px;
        color: #ccc;
      }
    }
  }
}
</style>
